// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1qNzr","left":"InfoRow_left__3MQov"};